module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./PromotionTreeView.js"));
	}, "PromotionTreeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PromotionTreeView!./src/pages/Learn/PromotionTree/PromotionTreeView.js
// module id = 1732
// module chunks = 418